import React from 'react';
// logic
import routes from 'utils/routes';
import useShowNewSoForm from 'refactored/features/soForm/useShowNewSoForm';
// styles
import styled, { css } from 'styled-components';
import { media } from 'utils/style';
import { useSelector } from 'react-redux';
import { selectors as authSelectors } from 'state/auth';
import { isTenantByName } from 'tenant/utils';

const AppBarSeparator = ({ className }) => {
  const showNewForm = useShowNewSoForm();

  const pathsWithoutAppBarSeparator = [
    routes.orders.default,
    routes.orders.previous,
    routes.orders.active,
    routes.orders.search,
    routes.dashboard,
  ];

  // if we are showing the new form service differenciation, we dont need this app bar separator
  // because the service differenciation design includes tabs
  if (showNewForm) {
    pathsWithoutAppBarSeparator.push(routes.newOrderCatalog);
  }

  const isPaymentMethodDenied =
    useSelector(authSelectors.getPaymentDataPaymentMethodValidationStatus) ===
    'DENIED';

  const pathname = window.location.pathname;
  const showAppBarSeparator =
    !isTenantByName('xpo') &&
    !isPaymentMethodDenied &&
    !pathsWithoutAppBarSeparator.some((path) => pathname.includes(path));
  if (!showAppBarSeparator) return <></>;
  return <div className={className}></div>;
};

const regularCSS = css`
  height: 16px;
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 1px);
  background: rgba(255, 255, 255, 0.95);
`;

const mobileCSS = css`
  display: none;
`;

export default styled(AppBarSeparator)`
  ${regularCSS}
  ${media.lessThan('small')`${mobileCSS}`}
`;
